<template>
  <div>
    <template v-if="isLoading">
      <b-row :class="formatClasses">
        <b-col class="flex-container">
          <font-awesome-icon
            icon="spinner" spin size="3x" style="color: #861f41">
          </font-awesome-icon>
          <span v-if="loadingMessage" id="loading-message">{{loadingMessage}}</span>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PageLoadingWrapper',
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    loadingMessage: {
      type: String,
      required: false,
    },
    /* String of css classes to add for styling */
    formatClasses: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style scoped>
  .flex-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #loading-message {
    margin-left: 2rem;
  }
</style>




// WEBPACK FOOTER //
// src/components/slots/PageLoadingWrapper.vue